'use strict';
const svgMarkupBuilder = require('./markup-builder').svgMarkupBuilder,
	convertThemeToFontMetrics = require('./font-metrics'),
	defaultTheme = require('@mindmup/mapjs-core/src/themes/theme-default'),
	pointAlongPath = require('./point-along-path'),
	buildBackgroundRect = function (dimensions, labelTheme) {
		return svgMarkupBuilder('rect').attr({
			x: 0,
			y: 2,
			width: Math.round(dimensions.width),
			height: Math.round(dimensions.height),
			fill: labelTheme.backgroundColor,
			stroke: labelTheme.borderColor
		});
	};


module.exports = function writeConnectorLabel(connectorProperties, fromNodePosition, toNodePosition, textEngine) {
	if (!connectorProperties || !connectorProperties.label) {
		throw new Error('invalid-args');
	}
	const defaultConnectorStyle = defaultTheme.node[0].connections.style,
		labelTheme = (connectorProperties.theme && connectorProperties.theme.label) || defaultTheme.connector[defaultConnectorStyle].label,
		calcReferencePoint = function () {
			const toNodeCenterpoint = toNodePosition.left + (toNodePosition.width / 2) - connectorProperties.position.left,
				fromNodeCenterpoint = fromNodePosition.left + (fromNodePosition.width / 2) - connectorProperties.position.left,
				lineWidthAttr = connectorProperties.theme && connectorProperties.theme.line && connectorProperties.theme.line.width,
				lineWidth = (Number.isFinite(lineWidthAttr) && lineWidthAttr) || 0;
			if (labelTheme.position.aboveEnd) {
				return {
					x: Math.round(fromNodeCenterpoint + (toNodeCenterpoint - fromNodeCenterpoint) * (labelTheme.position.ratio || 1)),
					y: toNodePosition.top - connectorProperties.position.top - labelTheme.position.aboveEnd - lineWidth
				};
			} else if (labelTheme.position.belowEnd) {
				return {
					x: Math.round(fromNodeCenterpoint + (toNodeCenterpoint - fromNodeCenterpoint) * (labelTheme.position.ratio || 1)),
					y: toNodePosition.top + toNodePosition.height - connectorProperties.position.top + labelTheme.position.belowEnd - lineWidth
				};
			} else if (Number.isFinite(labelTheme.position.aboveEndLeft)) {
				return {
					x: (fromNodePosition.left - connectorProperties.position.left),
					y: toNodePosition.top - connectorProperties.position.top - labelTheme.position.aboveEndLeft - lineWidth
				};

			} else if (labelTheme.position.ratio) {
				return pointAlongPath(connectorProperties.d, labelTheme.position.ratio);
			}
		},
		calcMidPoint = function () {
			return {
				x: connectorProperties.position.left + connectorProperties.position.width / 2,
				y: connectorProperties.position.top + connectorProperties.position.height / 2
			};
		},
		centrePoint = calcReferencePoint() || calcMidPoint(),
		labelText = connectorProperties.label && connectorProperties.label.trim(),
		fontMetrics = convertThemeToFontMetrics(labelTheme.text.font),
		dimensions = textEngine.lineSize(labelText, fontMetrics),
		preferredLeft = connectorProperties.position.left + Math.round(centrePoint.x - dimensions.width / 2),
		left = Math.max(preferredLeft, connectorProperties.position.left),
		top = connectorProperties.position.top + Math.round(centrePoint.y - dimensions.height),
		g = svgMarkupBuilder('g')
			.attr('transform', 'translate(' + left + ',' + top + ')');

	if ((labelTheme.backgroundColor && labelTheme.backgroundColor !== 'transparent') || (labelTheme.borderColor && labelTheme.borderColor !== 'transparent')) {
		buildBackgroundRect(dimensions, labelTheme).appendTo(g);
	}
	textEngine.writeLine(labelText, fontMetrics, labelTheme.text.color).appendTo(g);
	return g;
};
